import { useEffect, useState } from "react";
import { Users, RefreshCw } from "lucide-react";
import axios from "axios";
import { toast } from "sonner";
import { RippBadge } from "./primitives";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const btn = "rounded-sm border border-[var(--r2-border)] px-1.5 py-[2px] text-[8px] font-bold tracking-[0.14em] text-[var(--r2-text2)] hover:text-[var(--r2-text1)] disabled:opacity-40 flex items-center gap-1";

export const RippReachRow = ({ onReady }) => {
  const [a, setA] = useState(null);
  const [tg, setTg] = useState("");
  const [busy, setBusy] = useState(false);
  const check = async () => {
    setBusy(true);
    try { const r = (await axios.post(`${API}/launch-reach/check`)).data; setA(r); onReady?.(r.ready); }
    catch (e) { toast(e.response?.data?.detail || e.message); }
    setBusy(false);
  };
  useEffect(() => {
    axios.get(`${API}/launch-reach`).then((r) => { if (r.data.tg_members_manual != null) setTg(String(r.data.tg_members_manual)); }).catch(() => {});
    check();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const save = async (v = Number(tg)) => {
    setBusy(true);
    try { await axios.post(`${API}/launch-reach/config`, { tg_members_manual: Math.min(v, 1000000) }); toast(v < 0 ? "Manual count cleared" : "Telegram count saved"); if (v < 0) setTg(""); }
    catch (e) { toast(e.response?.data?.detail || e.message); }
    setBusy(false);
    check();
  };
  const tgOk = a && a.tg_members != null && a.tg_members >= a.target_tg;
  const xOk = a && a.x_followers != null && a.x_followers >= a.target_x;
  return (
    <div className="flex flex-wrap items-center gap-1.5 text-[8px]" data-testid="ripp-reach-row">
      <Users size={10} className="text-[var(--r2-cyan)]" />
      <span className={tgOk ? "text-[var(--r2-emerald)]" : "text-[var(--r2-text2)]"} data-testid="ripp-reach-tg">TG {a?.tg_members ?? "—"}/{a?.target_tg ?? 200}</span>
      <input value={tg} onChange={(e) => setTg(e.target.value.replace(/\D/g, ""))} placeholder="members" data-testid="ripp-reach-tg-input"
        className="w-16 rounded-sm border border-[var(--r2-border)] bg-transparent px-1 py-[1px] text-[9px] text-[var(--r2-text1)] focus:outline-none" />
      <button onClick={() => save()} disabled={busy || tg === ""} className={btn} data-testid="ripp-reach-tg-save">SAVE</button>
      <button onClick={() => save(-1)} disabled={busy} className={btn} data-testid="ripp-reach-tg-clear" title="clear manual count">CLEAR</button>
      <span className={xOk ? "text-[var(--r2-emerald)]" : "text-[var(--r2-text2)]"} data-testid="ripp-reach-x" title={a?.x_error || ""}>X {a?.x_followers ?? "—"}/{a?.target_x ?? 300}</span>
      <button onClick={check} disabled={busy} className={btn} data-testid="ripp-reach-refresh"><RefreshCw size={9} /></button>
      <RippBadge tone={a?.ready ? "emerald" : "amber"} testid="ripp-reach-status">{a?.ready ? "AUDIENCE READY" : "LAUNCH LOCKED"}</RippBadge>
    </div>
  );
};
